// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.logotype {
	align-items: center;
	font-size: 32px;
&.lg {
		font-size: 40px;
}
img {
		height: 3ch;
		margin-right: 1rem;
}
.underline {
		display: flex;
&>hr {
			flex-grow: 1;
}
}
}
`, "",{"version":3,"sources":["webpack://./src/components/LogoType.vue"],"names":[],"mappings":";AAoBA;CACC,mBAAmB;CACnB,eAAe;AAEf;EACC,eAAe;AAChB;AAEA;EACC,WAAW;EACX,kBAAkB;AACnB;AAEA;EACC,aAAa;AAEb;GACC,YAAY;AACb;AACD;AACD","sourcesContent":["<template lang=\"pug\">\n.logotype\n\tdiv.flex.center\n\t\timg(:src=\"VideoLogo\")\n\t\tspan Developing Tank\n\tdiv.underline(v-if=\"showBottom\")\n\t\thr.green.cozy.thick.l-dotted\n\t\thr.red.cozy.thick.l-dotted\n\t\thr.blue.cozy.thick.l-dotted\n\t\thr.yellow.cozy.thick.l-dotted\n</template>\n<script setup lang=\"ts\">\nimport VideoLogo from \"@/resources/icons8-video.png\";\n\nconst { showBottom = true } = defineProps<{\n\tshowBottom?: boolean\n}>();\n</script>\n\n<style>\n.logotype {\n\talign-items: center;\n\tfont-size: 32px;\n\n\t&.lg {\n\t\tfont-size: 40px;\n\t}\n\n\timg {\n\t\theight: 3ch;\n\t\tmargin-right: 1rem;\n\t}\n\n\t.underline {\n\t\tdisplay: flex;\n\n\t\t&>hr {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
